/* eslint-disable @typescript-eslint/no-unused-vars */
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

export type CTAStyling = 'primary' | 'secondary'

/* Schemas */
export const CTAStylingSchema = z.enum(['primary', 'secondary'])

/* Schemas validation */
type TestCTAStyling = ExpectTrue<
  Equal<CTAStyling, z.infer<typeof CTAStylingSchema>>
>
